import React from 'react'
import Template from './template'

const Otf = ({ viewBox }) => (
  <Template viewBox={viewBox}>
    <g>
      <path
        fill={'#E9E9E0'}
        d="M37,0H8C7.2,0,6.5,0.7,6.5,1.9V55c0,0.3,0.7,1,1.5,1H48c0.8,0,1.5-0.7,1.5-1V13c0-0.7-0.1-0.9-0.3-1.1
		L37.6,0.3C37.4,0.1,37.2,0,37,0z"
      />
      <polygon fill={'#D9D7CA'} points="37.5,0.2 37.5,12 49.3,12 	" />
      <path
        fill={'#7EA5BC'}
        d="M48,56H8c-0.8,0-1.5-0.7-1.5-1.5V39h43v15.5C49.5,55.3,48.8,56,48,56z"
      />
      <g>
        <path fill={'#FFFFFF'} d="M32,42.9v1.1h-3v9h-1.7v-9h-3v-1.1H32z" />
      </g>
      <path
        fill={'#C8BDB8'}
        d="M25.5,18c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.7s0.1-0.5,0.3-0.7c0.4-0.4,1-0.4,1.4,0
		c0.2,0.2,0.3,0.5,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7C26,17.9,25.8,18,25.5,18z"
      />
    </g>
    <path
      fill={'#FFFFFF'}
      d="M35.2,44.2v3.2h4.2v1.1h-4.2V53h-1.7V42.9h6.3v1.2H35.2z"
    />
    <g>
      <path
        fill={'#C8BDB8'}
        d="M33.4,10.9c-2,0-3.2-0.4-5.3-0.4c-6.6,0-9.6,3.7-9.6,7.5c0,2.2,1.1,3,3.2,3c-0.1-0.3-0.4-0.7-0.4-2.3
		c0-4.4,1.7-5.7,3.8-5.8c0,0-1.8,17.3-6.9,19.4v0.5h3.7h3.2l2.4-11.2h4.3l1-2.8H28l1.1-5.4c1.3,0.3,2.6,0.5,3.7,0.5
		c1.4,0,2.6-0.4,3.3-3.5C35.3,10.8,34.4,10.9,33.4,10.9z"
      />
    </g>
    <path
      fill={'#FFFFFF'}
      d="M23.5,47.9c0,0.8-0.1,1.6-0.3,2.2s-0.5,1.2-0.9,1.6c-0.4,0.4-0.8,0.8-1.3,1s-1.1,0.3-1.7,0.3s-1.2-0.1-1.7-0.3
	s-0.9-0.5-1.3-1s-0.7-1-0.9-1.6s-0.3-1.4-0.3-2.2s0.1-1.6,0.3-2.2c0.2-0.6,0.5-1.2,0.9-1.6c0.4-0.4,0.8-0.8,1.3-1s1.1-0.3,1.7-0.3
	s1.2,0.1,1.7,0.3s0.9,0.5,1.3,1c0.4,0.4,0.7,1,0.9,1.6C23.4,46.3,23.5,47.1,23.5,47.9z M19.2,51.7c0.3,0,0.7-0.1,1-0.2
	c0.3-0.1,0.6-0.3,0.8-0.6c0.2-0.3,0.4-0.7,0.6-1.2s0.2-1.1,0.2-1.8c0-0.7-0.1-1.3-0.2-1.7c-0.1-0.5-0.3-0.9-0.5-1.2
	s-0.5-0.5-0.8-0.7c-0.3-0.1-0.6-0.2-0.9-0.2c-0.3,0-0.7,0.1-1,0.2c-0.3,0.1-0.6,0.3-0.8,0.6c-0.2,0.3-0.4,0.7-0.6,1.2
	s-0.2,1.1-0.2,1.8c0,0.7,0.1,1.3,0.2,1.8s0.3,0.9,0.5,1.2s0.5,0.5,0.8,0.7C18.6,51.7,18.9,51.7,19.2,51.7z"
    />
  </Template>
)

export default Otf



// WEBPACK FOOTER //
// ./src/components/Svg/otf.js